
export default {
  props: {
    image: {
      type: URL,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    imagecss: {
      type: String,
      default: 'h-auto w-full rounded-[20px] object-contain',
      required: false,
    },
  },
  computed: {
    baseURL() {
      return this.$config.baseURL
    },
    pinImage() {
      return this.image.replace(
        'https://api.plantssogood.com',
        'https://ik.imagekit.io/rajumandapati/psg'
      )
    },
  },
}
